module.exports = __webpack_public_path__ + "fontawesome-webfont.af7ae505a9eed503f8b8.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/alexandre/Documents/web/riberfuso/resources/ng/src/assets/fonts/font-awesome-4.7.0/fonts/fontawesome-webfont.woff2?v=4.7.0
// module id = ../../../../../src/assets/fonts/font-awesome-4.7.0/fonts/fontawesome-webfont.woff2?v=4.7.0
// module chunks = 7